export const UI_AVATAR_COLOURS = [
  'lightBlue',
  'blue',
  'darkBlue',
  'lightGreen',
  'green',
  'darkGreen',
  'grey',
]



// WEBPACK FOOTER //
// ./src/constants/ui.js